<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    let image = this.$route.query.attached || null
    if (image != null) {
      this.$emitter.emit('SubModal', {
        name: 'full-screen-image-preview',
        data: {
          files: [image],
          config: {
            thumbnail: true,
            background: true
          }
        }
      })
    }
  }
}
</script>
